import { NoddiDatePicker, NoddiDatePickerProps } from '@ui-components/Overlay/Date/NoddiDatePicker';
import { useFieldContext } from '../formContext';
import { TanstackFieldError } from '../TanstackFieldError';
import { useTanstackFieldAria } from '../useTanstackFieldAria';

type Props = Omit<NoddiDatePickerProps, 'date' | 'onDateChange'>;

export const TanstackFormDatePicker = (rest: Props) => {
  const field = useFieldContext<Date | undefined>();
  const fieldAria = useTanstackFieldAria(field, rest['aria-describedby']);

  return (
    <div>
      <NoddiDatePicker
        {...rest}
        id={rest.id ?? field.name}
        name={field.name}
        {...fieldAria}
        date={field.state.value}
        onDateChange={(date) => field.handleChange(date)}
      />
      <TanstackFieldError field={field} />
    </div>
  );
};
